import { render, staticRenderFns } from "./CanvasDraw.vue?vue&type=template&id=7d37481e&scoped=true"
import script from "./CanvasDraw.vue?vue&type=script&lang=js"
export * from "./CanvasDraw.vue?vue&type=script&lang=js"
import style0 from "./CanvasDraw.vue?vue&type=style&index=0&id=7d37481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37481e",
  null
  
)

export default component.exports